import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { Input, Radio, SearchInput, Select } from "../../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";

export default function CrearArchivoTxt({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Crear archivo TXT</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="w-auto float-none m-0">
            Seleccione El Banco Al cual desea generar el txt
          </legend>
          <div className="col-auto m-0 mb-2 p-0">
            <Radio label = 'Pago Nominal' name = 'tipoPago' id = 'tipoPago1'/>
          </div>
          <div className="col-auto m-0 mb-2 p-0 pl-2">
            <Radio label = 'Pago de Vacaciones' name = 'tipoPago' id = 'tipoPago2'/>
          </div>
          <div className="col-auto m-0 mb-2 p-0 pl-2">
            <Radio label = 'Otro Pago' name = 'tipoPago' id = 'tipoPago3'/>
          </div>
          <div className="col-auto m-0 mb-2 p-0 pl-2">
            <Radio label = 'Anticipo de Prestaciones' name = 'tipoPago' id = 'tipoPago4'/>
          </div>
          <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
            <div className="col-auto m-0 p-0">
              <Radio label = 'Bicentenario' name = 'banco' id = 'banco1'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Venezuela' name = 'banco' id = 'banco2'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Banesco' name = 'banco' id = 'banco3'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Caroni' name = 'banco' id = 'banco4'/> 
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Sofitasa' name = 'banco' id = 'banco5'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'B.O.D' name = 'banco' id = 'banco6'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Sofitasa Nuevo' name = 'banco' id = 'banco7'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'Patria' name = 'banco' id = 'banco8'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Radio label = 'fideicomiso' name = 'banco' id = 'banco9'/>
            </div>
          </div>
          <div className="col-4 m-0 mb-2 p-0">
            <Input label = 'Fecha de pago:' type = 'date'/>
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-2">
            <Input label = 'Nº Carta Orden:' /> 
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-2">
            <Input label = 'Cod. Agencia Bancaria:' />
          </div>
          <div className="col-4 m-0 mb-2 p-0">
            <Select label = 'Clase Txt:' ></Select>
          </div>
          <div className="col-12 m-0 mb-2 p-0 d-flex align-items-center gap-2">
            <span className="fw-bold">Fecha de Vacaciones:</span>
            <div className="col-auto m-0 p-0">
              <Input label = 'Desde:' type = 'date'/>
            </div>
            <div className="col-auto m-0 p-0">
              <Input label = 'Hasta:' type = 'date'/>
            </div>
          </div>
          <div className="col-6 m-0 mb-2 p-0 d-flex align-items-center gap-2">
            <span className="fw-bold">Período de Vacaciones:</span>
            <div className="col m-0 p-0">
              <Input />
            </div>
            <div className="col m-0 p-0">
              <Input />
            </div>
          </div>
          <div className="col-6 m-0 mb-2 p-0 pl-2">
            <Input label = 'Num. Cuenta a Debitar:' />
          </div>
          <div className="col-3 m-0 p-0">
            <SearchInput label = 'Cod. Banco:' />
          </div>
          <div className="col-9 m-0 p-0 pl-2">
            <Input label = 'Descripción:' />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
